import { EMOJI_CATALOG } from "./emoji-catalog";

const emojiByName = new Map(EMOJI_CATALOG.map((item) => [item.name, item.emoji]));

export function renderEmojiAsUnicode(name: unknown) {
  if (typeof name !== "string" || !name) {
    return "";
  }

  return emojiByName.get(name) ?? `:${name}:`;
}
